import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.dialogSyncHealthStateOpen,
      "max-width": "900",
      "buttons": [{
        title: this.$i18n_t('Common.apply'),
        type: 'button',
        action: 'syncHealthStates',
        valid: !_vm.isApplyBtnInDialogDisabled
      }]
    },
    on: {
      "close": _vm.closeSyncHealthStateDialog,
      "syncHealthStates": _vm.syncHealthStates
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applySyncHealthState', {
          n: _vm.getTotalDevicesNumber
        })) + "\n  ")];
      },
      proxy: true
    }])
  }, [[_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.changesApplied', {
    n: _vm.getTotalDevicesNumber
  })))])], _c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.addTitle')))]), _c(VTextField, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyChangesLabel'),
      "rules": _vm.rules,
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.jobTitle,
      callback: function ($$v) {
        _vm.jobTitle = $$v;
      },
      expression: "jobTitle"
    }
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };